(() => {
  'use strict';
  if (window.PoptexStoreChrome) { window.PoptexStoreChrome.mount(); return; }
  let dispose = () => {}, close = () => {};
  function mount() {
    dispose();
    const root = document.querySelector('[data-store-chrome]');
    if (!root) return;
    const controller = new AbortController(), signal = controller.signal;
    const on = (target, type, handler, options = {}) => target?.addEventListener(type, handler, { ...options, signal });
    const menu = root.querySelector('[data-store-menu]'), toggle = root.querySelector('[data-store-menu-toggle]');
    const scrim = root.querySelector('[data-store-menu-scrim]'), dismiss = root.querySelector('[data-store-menu-close]');
    const desktop = root.querySelector('.chrome-desktop-header'), mobile = root.querySelector('.chrome-mobile-nav');
    const breakpoint = matchMedia('(min-width:1024px)');
    const products = [...root.querySelectorAll('[data-store-products]')];
    const closeProducts = (restoreFocus = false) => {
      products.forEach(details => {
        if (!details.open) return;
        details.open = false;
        details.querySelector('summary').setAttribute('aria-expanded', 'false');
        if (restoreFocus) details.querySelector('summary').focus({ preventScroll: true });
      });
    };
    const syncProducts = () => {
      if (signal.aborted) return;
      const registry = window.PoptexContentRegistry;
      const snapshot = registry?.getReadonlySnapshot?.() || registry?.getSnapshot?.();
      if (!snapshot || !window.PoptexProductContent) return;
      const catalog = window.PoptexProductContent.catalog(snapshot);
      const groups = catalog.groups.filter(group => catalog.styles.some(style => style.groupId === group.id))
        .slice().sort((a,b) => (Number(b.sortOrder)||0) - (Number(a.sortOrder)||0) || String(a.code || a.id).localeCompare(String(b.code || b.id)));
      products.forEach(details => {
        const list = details.querySelector('[data-store-product-categories]');
        const entries = new Map([...list.children].map(link => [link.dataset.groupId, link]));
        let previous = null;
        groups.forEach(group => {
          let link = entries.get(group.id);
          if (!link) { link = document.createElement('a'); link.dataset.groupId = group.id; }
          entries.delete(group.id);
          const name = group.shortName?.trim() || group.name;
          if (link.textContent !== name) link.textContent = name;
          link.href = details.dataset.productsUrl + '?material=' + encodeURIComponent(group.id);
          if ((previous ? previous.nextElementSibling : list.firstElementChild) !== link) list.insertBefore(link, previous ? previous.nextElementSibling : list.firstElementChild);
          previous = link;
        });
        entries.forEach(link => {
          if (link === document.activeElement) details.querySelector('summary').focus({ preventScroll: true });
          link.remove();
        });
        details.querySelector('[data-store-materials]').hidden = groups.length === 0;
      });
    };
    products.forEach(details => {
      const summary = details.querySelector('summary');
      let hoverTimer;
      const cancelHoverClose = () => window.clearTimeout(hoverTimer);
      signal.addEventListener('abort', cancelHoverClose, {once:true});
      on(details, 'pointerenter', event => {
        cancelHoverClose();
        if (!breakpoint.matches || event.pointerType !== 'mouse') return;
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      });
      on(details, 'pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        cancelHoverClose();
        hoverTimer = window.setTimeout(() => {
          if (details.contains(document.activeElement)) return;
          details.open = false;
          summary.setAttribute('aria-expanded', 'false');
        }, 180);
      });
      on(details, 'focusout', event => {
        if (!details.contains(event.relatedTarget) && !details.matches(':hover')) {
          details.open = false;
          summary.setAttribute('aria-expanded', 'false');
        }
      });

      on(details, 'toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
        if (details.open) products.filter(other => other !== details).forEach(other => { other.open = false; other.querySelector('summary').setAttribute('aria-expanded', 'false'); });
      });
      on(summary, 'keydown', event => {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
        details.querySelector('a').focus();
      });
    });
    on(document, 'pointerdown', event => {
      products.forEach(details => {
        if (!details.contains(event.target)) { details.open = false; details.querySelector('summary').setAttribute('aria-expanded', 'false'); }
      });
    });
    on(window, 'poptex:metadata-updated', syncProducts);
    syncProducts();
    window.PoptexContentRegistry?.init?.().then(syncProducts).catch(() => {});
    let open = false, frame = 0;
    const setOpen = (value, restoreFocus = true) => {
      if (!value) closeProducts();
      open = value;
      menu.classList.toggle('is-open', value);
      scrim.classList.toggle('is-open', value);
      menu.inert = !value;
      menu.setAttribute('aria-hidden', String(!value));
      toggle.setAttribute('aria-expanded', String(value));
      document.body.classList.toggle('poptex-store-menu-open', value);
      if (value) dismiss.focus({ preventScroll: true });
      else if (restoreFocus) toggle.focus({ preventScroll: true });
    };
    close = restoreFocus => setOpen(false, restoreFocus);
    const update = () => {
      frame = 0;
      desktop.classList.toggle('is-scrolled', scrollY > 35);
      const hero = [...document.querySelectorAll('[data-gift-hero],.bpl-showroom .hero,.hero--immersive,.hero-v2')].find(el => el.getClientRects().length);
      mobile.classList.toggle('is-scrolled', hero ? hero.getBoundingClientRect().bottom < innerHeight * .22 : scrollY > innerHeight * .7);
    };
    const queueUpdate = () => { if (!frame) frame = requestAnimationFrame(update); };
    on(toggle, 'click', () => setOpen(!open));
    on(dismiss, 'click', () => close());
    on(scrim, 'click', () => close());
    on(menu, 'click', event => { if (event.target.closest('a')) close(false); });
    on(document, 'keydown', event => {
      if (event.key === 'Escape' && products.some(details => details.open)) { event.preventDefault(); closeProducts(true); return; }
      if (!open) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (event.key !== 'Tab') return;
      const items = [...menu.querySelectorAll('a,button,input,summary')].filter(el => !el.disabled && el.getClientRects().length);
      if (event.shiftKey && document.activeElement === items[0]) { event.preventDefault(); items.at(-1).focus(); }
      else if (!event.shiftKey && document.activeElement === items.at(-1)) { event.preventDefault(); items[0].focus(); }
    });
    on(breakpoint, 'change', () => { close(false); update(); });
    on(window, 'scroll', queueUpdate, { passive: true });
    on(window, 'resize', queueUpdate, { passive: true });
    on(window, 'pageshow', () => { close(false); update(); });
    on(document, 'poptex:hero-tone', event => desktop.classList.toggle('is-light', !!event.detail?.light));
    on(document.querySelector('[data-store-back-top]'), 'click', event => {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    });
    setOpen(false, false);
    update();
    dispose = () => { setOpen(false, false); controller.abort(); cancelAnimationFrame(frame); };
  }
  window.PoptexStoreChrome = { mount, close: restoreFocus => close(restoreFocus) };
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', () => { queueMicrotask(mount); });
  mount();
})();
